module.exports = __webpack_public_path__ + "img/Hamsun_USA-opphold.7a8a3039.jpg";